import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const Auth0CallbackV2View = () => {
  console.log('/callback v2 hit');
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');

  useEffect(() => {
    window.location.href = `${process.env.REACT_APP_AUTH0_USER_API_CALLBACK_V2}?code=${code}`;
  }, []);

  return <></>;
};

export { Auth0CallbackV2View };
